<template>
  <div
    id="app"
    class="wsk-root wsk-app ws-fields-arrangement"
    :class="'theme--' + theme"
  >
    <q-layout view="lHh Lpr lFf">
      <ws-drawer v-if="sidePanel" v-model="sidePanel" class="layout-drawer" full-height-content>
        <component
          :is="item.name"
          v-for="item in loginStore.items"
          :key="item.name"
        />
      </ws-drawer>

      <q-page-container>
        <router-view>
          <div class="loader-wrapper ws-min-height-1000 full-width">
            <ws-spinner spinner-type="circular" width="20px" text="general.loading_msg" />
          </div>
        </router-view>
      </q-page-container>

      <portal-target name="layout-default">
        <!--
        This content can be located anywhere in App.
        search for </portal> with attribute "to" set to same name as here "name" attribute
        -->
      </portal-target>
    </q-layout>

    <theme-switcher v-if="$store.state.devUtils" />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed, getCurrentInstance } from 'vue';
import { QLayout, QPageContainer } from 'quasar';
import { isBrowser } from '@odin/utils';
import WsDrawer from '@/components/WsDrawer.vue';
import config from '@/services/config.service';
import {SidePanels, StateMutations} from '@/store/const.enum';
import {useLoginStore} from '@/store/pinia/login.store';
import { useTheming } from '@odin/vue2-utils';
import { WsSpinner } from '@odin/components-vue2';

export default defineComponent({
  components: {
    QLayout,
    QPageContainer,
    WsSpinner,
    WsDrawer
  },
  setup() {
    const instance = getCurrentInstance();
    const loginStore = useLoginStore();
    const { theme } = useTheming();

    onMounted(() => {
      if (!isBrowser) {
        return;
      }

      setTemplateCheckoutMinHeight();
    });

    function setTemplateCheckoutMinHeight() {
      const tmplElm = document.getElementsByClassName('template-checkout')?.[0];
      if (tmplElm) { (tmplElm as HTMLElement).style.minHeight = '0';}
    }

    const sidePanel = computed({
      get() {
        return instance?.proxy.$store.state.ui.sidePanel !== SidePanels.Hidden;
      },
      set(newVal: boolean) {
        instance?.proxy.$store.commit(StateMutations.MERGE_STATE, {
          ui: { sidePanel: newVal ? SidePanels.Login : SidePanels.Hidden },
        });
      }
    });
    return {
      conf: config,
      sidePanel,
      loginStore,
      theme,
    };
  }
});
</script>

<style lang="scss" scoped>
.wsk-root.wsk-app {
  background-color: $body-bg;
}

.wsk-root:not(.theme--admin) .q-layout {
  min-height: inherit !important;
}

.layout-drawer {
  max-width: 100%;
  ::v-deep {
    .q-drawer .q-drawer__content {
      padding: map-get($space-3xl, y) map-get($space-3xl, x)
      map-get($space-lg, y);
    }
  }
}

.loader-wrapper {
  height: 500px;
}
</style>
